import { Pano } from "../Pano.js";
import { PanoButton } from "../PanoButton.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";

export class ControlTimer extends BaseControl {
    private _button: PanoButton;

    constructor(pano: Pano) {
        super(pano);

        this._video.addEventListener("canplay", () => this.render());
        this._video.addEventListener("timeupdate", () => this.render());
        this.pano.onChangeVideo.add(() => this.render());

        this._button = this.pano.addButton(
            {
                position: ControlPosition.LEFT
            }
        );

        this.render();
    }

    private render(): void {
        const current = this.secondsToTimestring(this._video.duration ? this._video.currentTime : NaN);
        const duration = this.secondsToTimestring(this._video.duration);
        this._button.html = `
            <div class="timer-current">${current}</div>
            <div class="timer-separator">/</div>
            <div class="timer-duration">${duration}</div>
        `;
    }

    private secondsToTimestring(seconds: number): string {
        if (isNaN(seconds))
            return "0:00";
        seconds = Math.round(seconds);
        var minutes = Math.floor(seconds / 60);
        var secondsLeft = seconds % 60;
        return minutes + ":" + ((secondsLeft < 10) ? "0" + secondsLeft : secondsLeft);
    }
}